import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  id: "group-menu-dropdown-container",
  class: "group-menu"
}
const _hoisted_2 = {
  id: "group-menu-dropdown-content",
  class: "group-menu__dropdown"
}
const _hoisted_3 = ["onClick"]

import { i18n } from '@/i18n';
import { GROUP_MENU_ITEMS } from '../constants';
import { GroupMenuService } from '../domains/services/groupMenuService';
import { nextTick, onMounted, onUnmounted, ref } from 'vue';
import { GroupMenuItems } from '../domains/entities/GroupMenu';
import { watch } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';

const OPTION_HEIGHT = 40;


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupMenuDropdown',
  props: {
    isSelectedBusinesses: { type: Boolean },
    isOpenProp: { type: Boolean },
    selectedItemProp: {}
  },
  emits: ["click:selectInput", "selectedItem", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const t = i18n.t;

const selectedItem = ref<GroupMenuItems>();
const isOpen = ref(false);

const emit = __emit;

watch(
  () => props.isOpenProp,
  () => {
    isOpen.value = props.isOpenProp || false;
  }
);

watch(
  () => props.selectedItemProp,
  () => {
    selectedItem.value = props.selectedItemProp;
  }
);

watch(isOpen, async (newVal) => {
  if (newVal) {
    emit('click:selectInput');
    calculateDropdownPosition();
  }
});

/**
 * ドロップダウンの表示状態を切り替えます。
 */
const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

/**
 * グループメニューの項目を非活性にするかどうか
 * @param item - グループメニューの項目
 */
const isDisabledItem = (item: GroupMenuItems): boolean => {
  return GroupMenuService.isBusinessRelatedItem(item) && !props.isSelectedBusinesses;
};

/**
 * オプションを選択し、親コンポーネントに選択値を通知します。
 * @param item - 選択したアイテム
 */
const selectOption = (item: GroupMenuItems) => {
  selectedItem.value = item;
  emit('selectedItem', item);
  isOpen.value = false;
  emit('close');
};

/**
 * ドロップダウンを閉じます。
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!isOpen.value) return;
  const target = event.target;
  const selector = '#group-menu-dropdown-container';
  const arrowSelector = '#group-menu-dropdown-arrow';
  const searchSelector = '#group-menu-dropdown-content';
  if (!(target instanceof Element)) return;
  if (target.closest(arrowSelector)) return;
  if (target.closest(selector)) return;
  if (target.closest(searchSelector)) return;

  isOpen.value = false;
  emit('close');
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
  document.addEventListener('click', closeDropdown);
});

/**
 * ドロップダウンの位置を計算し、設定します。
 */
const calculateDropdownPosition = () => {
  nextTick(() => {
    const selectBox = document.querySelector('#group-menu-dropdown-container') as HTMLElement;
    if (selectBox) {
      const rect = selectBox.getBoundingClientRect();
      const dropdown = document.querySelector('#group-menu-dropdown-content') as HTMLElement;
      if (dropdown) {
        dropdown.style.left = `${rect.left}px`;
        dropdown.style.top = `${rect.bottom}px`;

        // ドロップダウンの高さを計算
        const desiredHeight = OPTION_HEIGHT * GROUP_MENU_ITEMS.length;

        // max-heightを計算して設定
        const availableHeight = window.innerHeight - rect.bottom - 10; // 10pxは少しのマージン
        dropdown.style.maxHeight = `${Math.min(desiredHeight, availableHeight)}px`;
      }
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "group-menu_container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDropdown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "group-menu__selected",
        onClick: toggleDropdown
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`group-menu__field ${selectedItem.value === undefined ? 'group-menu__field--placeholder' : ''}`)
        }, _toDisplayString(selectedItem.value === undefined ? _unref(t)('グループ') : _unref(GroupMenuService).getDisplayText(selectedItem.value)), 3),
        (isOpen.value)
          ? (_openBlock(), _createBlock(SvgLoader, {
              key: 0,
              name: "arrowUpBlue",
              class: "group-menu__arrow"
            }))
          : (_openBlock(), _createBlock(SvgLoader, {
              key: 1,
              id: "group-menu-dropdown-arrow",
              name: "arrowDownBlue",
              class: "group-menu__arrow"
            }))
      ]),
      (isOpen.value)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 0,
            to: "body"
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GROUP_MENU_ITEMS), (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option,
                  class: _normalizeClass(["group-menu__option", { 'group-menu__option--disabled': isDisabledItem(option) }]),
                  onClick: ($event: any) => (!isDisabledItem(option) && selectOption(option))
                }, _toDisplayString(_unref(GroupMenuService).getDisplayText(option)), 11, _hoisted_3))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})